export class FeaturePlugin {
  constructor() {
    this.pluginName = null;
  }
  getFeatureFunctionalityCached() {
    if (!this.__def) {
      const builder = this.getFunctionalityBuilder();
      this.getFeatureFunctionality(builder);
      // NOTE: removed cloning, __def can potentially mutate original configuration!
      // this was done because config may contain classes / instances, which would become plain objects if using objectCloneDeep.
      this.__def = builder.getConfig();
    }
    return this.__def;
  }
  // // lifecycle events
  onFeatureInit() {}
  onFeatureDestroy() {}
}